(function($){
    jQuery(document).ready(function(){
        $("h1, h2, h3, h4, h5, h6").addClass("header-font");
    })}
)(jQuery);
